import React,{ useEffect, useState, useContext } from "react";
import { withTranslation } from "react-i18next";
import {Button,Form,FormControl,InputGroup, Card, Col,Row, Modal, Alert } from "react-bootstrap"
import { BsChatDotsFill, BsMic, BsQuestionSquare } from "react-icons/bs";
import { RiArrowLeftSLine,RiArrowRightSLine} from "react-icons/ri";
import SimpleTable from "../components/SimpleTable";
import DateInputFilter from "../components/DateInputFilter";
import { authContext } from "../context/AuthContext";
import ReactPaginate from "react-paginate";
import SimpleLoad from "../loader/SimpleLoad";
import moment from "moment";
import { FaFileAlt,FaRegFilePdf,FaSearch} from "react-icons/fa";
import Get from "../api/Get";
import { CHAT_GET_BY_TOKENID, DOCUMENT_GET_BY_APPOINTMENTPUBLIC, GET_APPOINTMENT_BY_ID, GET_CHECKLIST_DOCUMENTS, GET_SURVEY_BY_APPOINTMENT, NOTIFICACIONES_BY_APPOINTMENT, RECORDING_GET_BY_APPOINTMENT, TRAZABILIDAD_LIST } from "../api/Routes";
//Contenido de Docs y chats
import ListDocuments from "../pages/Trazabilidad/ListDocuments";
import ListChats from "../pages/Trazabilidad/ListChats";
import { toast } from "react-toastify";
import ListRecording from "../pages/Trazabilidad/ListRecording";
import ComponentModalErrorSever from '../components/ComponentModalErrorSever'
import { AiOutlineMail } from "react-icons/ai";
import ListNotificacion from "../pages/Trazabilidad/ListNotificacion";
import { HiOutlineViewList } from "react-icons/hi";
import ModalDetailAppointment from "./modal/ModalDetailAppointment";
import Survey from "../pages/cita/Survey";

function Trazability(props) {
  const {t} = props;
  
  const [loading, setLoading] = useState(true);
  const { auth } = useContext(authContext);
  const [items, setItems] = useState([]);
  const [pageSize, setCount] = useState(20);
  const [sortBy, setOrder] = useState("id");
  const [pageCount, setPageCount] = useState(0);
  const [pageNo, setPage] = useState(0);
  const [valueSearch, setValueSearch] = useState("");
  const [search,   setSearch] = useState("%20");
  const [typeSort, setTypeSort] = useState("asc");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date()); 
  /////
  const [trazabilityPage, setTrazabilityPage] = useState(true);
  const [documentPage, setDocumentPage] = useState(false);
  const [chatPage, setChatPage] = useState(false);
  const [recordingPage, setRecordingPage] = useState(false);
  const [notificacionPage, setNotificacionPage] = useState(false);
  const [detailPage, setDetailPage] = useState(false);
  const [surveyPage, setSurveyPage] = useState(false);

  //document
  const [documents, setDocuments] = useState([]); 
  //chats
  const [chats, setChats] = useState([]) 
  const [expediente, setExpediente] = useState(null)
  //recording
  const [records, setRecords] = useState([]); 
  //notifications
  const [notificaciones, setNotificaciones] = useState([])
  //detalle de la cita
  const [infoCita, setInfoCita] = useState(null)
  //surveys
  const [surveys, setSurveys] = useState(null)

  //error server
  const [showModalError, setShowModalError] = useState(false)
  const [errorServer, setErrorServer] = useState(null)
  const handleClose = () => setShowModalError(false)

  //documentos a enviar
  const [modalShow, setModalShow] = useState(false)
  const [sendingDoc, setSendingDoc] = useState(false)
  const [docuemntosEnviar, setDocumenosEnviar] = useState(null)
  const [existDocuments, setExistsDocuments] = useState(true)
  const handleCloseModal = () => setModalShow(false);
  
    useEffect(() => {
      if(endDate){
        let mounted = true;
        setLoading(true);
        const url = `${TRAZABILIDAD_LIST}/${pageNo}/${pageSize}/${sortBy}/${typeSort}?endDate=${moment(endDate).format("YYYY-MM-DD")}&search=${search}&startDate=${moment(startDate).format("YYYY-MM-DD")}`;
        Get({ url: url, access_token: auth.data.access_token })
          .then((response) => {
            if(mounted){
              setItems(response.data.data.response.content);
              setPageCount(response.data.data.response.totalPages);
              setLoading(false);
            }
          })
          .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false);
          });
          return () => mounted = false;
      }
      
    }, [pageCount, pageNo, search, endDate]);
    
    const handlePageClick = (data) => {
      setPage(data.selected);
    };
  
    const searchPatient = (e) => {
      e.preventDefault();
      if (valueSearch === "") {
        setSearch("%20");
      } else {
        setSearch(valueSearch);
      }
      setPage(0);
    };

    const documentosParaDescargar = async (id) =>{
      setModalShow(true);
      setSendingDoc(true)
      setExistsDocuments(true)
      try {
          const response = await Get({url: `${GET_CHECKLIST_DOCUMENTS}/${id}`, access_token: auth.data.access_token})
          //console.log(response)
          if(response.data.state){
              setSendingDoc(false)
              setDocumenosEnviar(response.data.data)
              if(!response.data.data.ficha && !response.data.data.historia && !response.data.data.receta
                  && !response.data.data.incapacidad && !response.data.data.recomendacion && !response.data.data.remision
                  && !response.data.data.estudios && !response.data.data.laboratorio){
                      setExistsDocuments(false)
              }
          }else{
              setSendingDoc(false)
              setDocumenosEnviar(null)
              setExistsDocuments(false)
          }
      } catch (error) {
          setSendingDoc(false)
          setShowModalError(true)
          setErrorServer(error?.response)
      }
  }
  
    const actions = (cell, row, index) => {
      return (
          <div>
              <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <span onClick={() => {onChangeLoadPage({view: "documents", id: row.id})}}><FaFileAlt className='iconAction colorAzul' /></span>
                  </li>
                  <li className="list-inline-item"><span onClick={() => {onChangeLoadPage({view: "chats", row: row})}}><BsChatDotsFill className='iconAction colorVerde' /></span></li>
                  <li className="list-inline-item"><span onClick={() => {onChangeLoadPage({view: "recording", id: row.id})}}><BsMic className='iconAction text-warning' /></span></li>
                  <li className="list-inline-item"><span onClick={() => {onChangeLoadPage({view: "notification", id: row.id})}}><AiOutlineMail className='iconAction text-secondary' /></span></li>
                  <li className="list-inline-item">
                    <span onClick={() => {onChangeLoadPage({view: "detail", id: row.id})}}>
                      <HiOutlineViewList className='iconAction text-primary' />
                    </span>
                  </li>
                  <li className="list-inline-item"><span onClick={() => {onChangeLoadPage({view: "survey", id: row.id})}}><BsQuestionSquare className='iconAction text-secondary' /></span></li>
                  <li className="list-inline-item"><span onClick={() => documentosParaDescargar(row.id)}><FaRegFilePdf className='iconAction text-danger' /></span></li>
                  
              </ul>          
          </div>
      );
  }
    const fillName = (cell, row) => {
      let firstName = `${row.patientDTO.name ?? ''}`
      let secname = `${row.patientDTO.middleName ?? ''}`
      let firstAp = `${row.patientDTO.lastName ?? ''}`
      let secAp = `${row.patientDTO.seccondSurname ?? ''}`
      return `${firstName} ${secname} ${firstAp} ${secAp}`
    }
      
    const fillDate = (cell, row) => {
      return moment(row.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")
    }
  
    const columns = [
      {
        dataField: "id",
        text: "ID",
        hidden: true,
      },
      {
        dataField: "expediente",
        text: "Nro Expediente",
        headerStyle: { width: "10%" },
      },
      {
        dataField: "name",
        text: "Nombre",
        headerStyle: { width: "15%" },
        formatter:fillName,
      },
      {
        dataField: "speciality.name",
        text: "Servicio",
        headerStyle: { width: "15%" },
      },
      {
        dataField: "patientDTO.account.name",
        text: "Cuenta",
        headerStyle: { width: "20%" },
      },
      {
        dataField: "created_at",
        text: "Fecha y Hora",
        headerStyle: { width: "10%" },
        formatter:fillDate
      },
      {
        dataField: "",
        isDummyField: true,
        text: "ACCIONES",
        style: {
          textAlign: "center",
        },
        headerStyle: { width: "30%", textAlign: "center" },
        formatter: actions,
      },
    ];

    
    const fecthDocument = (id) =>{
      const url = `${DOCUMENT_GET_BY_APPOINTMENTPUBLIC}/${id}`;
      Get({ url: url, access_token: auth.data.access_token })
      .then((response) => {
        if(response.data.data.response.length > 0){
          setChatPage(false);
          setTrazabilityPage(false);
          setDocumentPage(true);
          setRecordingPage(false)
          setNotificacionPage(false)
          setDocuments(response.data.data.response);
          setLoading(false);
        }else{
          setLoading(false)
          toast.error(t('archivos_vacios'), {autoClose: 6000})
        }          
      })
      .catch((error) => {
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      });

      Get({url: `${GET_APPOINTMENT_BY_ID}/${id}`, access_token: auth.data.access_token})
      .then(response=>{
        setInfoCita(response.data.data)
      })
      .catch(error=>{
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      })
    }

    const fecthChat = (tokenId) =>{
      const url = `${CHAT_GET_BY_TOKENID}/${tokenId}`;
      Get({url: url, access_token: auth.data.access_token})
      .then(response=>{
        if(response.data.data.response.length > 0){
          setDocumentPage(false);
          setTrazabilityPage(false);
          setChatPage(true);
          setChats(response.data.data.response);
          setRecordingPage(false)
          setNotificacionPage(false)
          setLoading(false);
        }else{
          setLoading(false)
          toast.error(t('chats_vacios'), {autoClose: 6000})
        }  
      })
      .catch(error=>{
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      }) 
    }

    const fecthRecording = (id) =>{
      const url = `${RECORDING_GET_BY_APPOINTMENT}/${id}`;
      Get({url: url, access_token: auth.data.access_token})
      .then(response=>{
        if(response.data.data.response.length > 0){
          setRecords(response.data.data.response)
          setDocumentPage(false);
          setTrazabilityPage(false);
          setChatPage(false);
          setNotificacionPage(false)
          setRecordingPage(true)
        }else{
          toast.error(t('recording_vacios'), {autoClose: 6000})
        }
        setLoading(false)
      })
      .catch(error=>{
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      })
    }

    const fetchNotification = id =>{
      Get({url: `${NOTIFICACIONES_BY_APPOINTMENT}/${id}`, access_token: auth.data.access_token})
      .then(response=>{
        if(response.data.data.response.length > 0){
          setChatPage(false);
          setTrazabilityPage(false);
          setDocumentPage(false);
          setRecordingPage(false)
          setNotificaciones(response.data.data.response);
          setLoading(false);
          setNotificacionPage(true)
        }else{
          setLoading(false)
          toast.error(t('notificaciones_vacias'), {autoClose: 6000})
        }
      })
      .catch(error=>{
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      })
    }

    const fetchAppointment = id =>{
      Get({url: `${GET_APPOINTMENT_BY_ID}/${id}`, access_token: auth.data.access_token})
      .then(response=>{
        //console.log(response)
        setInfoCita(response.data.data)
        setDetailPage(true)
        setLoading(false)
      })
      .catch(error=>{
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      })
    }
    const fetchSurvey = id =>{
      Get({url: `${GET_SURVEY_BY_APPOINTMENT}/${id}`, access_token: auth.data.access_token})
      .then(response=>{
        //console.log(response)
        if(Object.keys(response.data.data.response).length > 0){
          setChatPage(false);
          setTrazabilityPage(false);
          setDocumentPage(false);
          setRecordingPage(false)
          setSurveys(response.data.data.response);
          setLoading(false);
          setNotificacionPage(false)
          setSurveyPage(true)
        }else{
          setLoading(false)
          toast.error("La videoconsulta correspondiente a este expediente, no tiene respuesta para la encuesta.", {autoClose: 6000})
        }
       
      })
      .catch(error=>{
        setShowModalError(true)
        if(error.response){
            setErrorServer(error.response)
        }
        setLoading(false)
      })
    }

    const onChangeLoadPage = (typePage) => {
        if (typePage.view === "trazabilidad"){
          setChatPage(false);
          setDocumentPage(false);
          setRecordingPage(false)
          setTrazabilityPage(true);
          setNotificacionPage(false)
          setSurveyPage(false)
        } else if (typePage.view === "documents"){
          setLoading(true)
          fecthDocument(typePage.id)
        } else if (typePage.view === "chats"){
          setLoading(true)
          setExpediente(typePage.row.expediente)
          fecthChat(typePage.row.token_conference)
        }else if(typePage.view === 'recording'){
          setLoading(true)
          fecthRecording(typePage.id)
        }else if(typePage.view==='notification'){
          setLoading(true)
          fetchNotification(typePage.id)
        }  
        else if(typePage.view==='detail'){
          setLoading(true)
          fetchAppointment(typePage.id)
        }else if(typePage.view==='survey'){
          setLoading(true)
          fetchSurvey(typePage.id)
        }  
    };
 
  const listTrazability = ()=>{
    return (
        <>
          <Row className="align-items-center">
              <Col xs="12" md="6">
                <h2 className="mb-0 title-top">Trazabilidad de citas</h2>
              </Col>
              <Col xs="12" md="6">
                <div className="d-flex justify-content-end align-items-center">
                  <div className="mr-5">
                    <DateInputFilter 
                      startDate ={startDate} 
                      setStartDate ={setStartDate}
                      endDate ={endDate}
                      setEndDate ={setEndDate}
                    />
                  </div>
                  <div>
                    <Form onSubmit={searchPatient}>
                      <InputGroup>
                        <FormControl
                          placeholder={t("buscar")}
                          className="input-1"
                          value={valueSearch}
                          onChange={(e) => setValueSearch(e.target.value)}
                        />
                        <InputGroup.Append>
                          <Button
                            type="submit"
                            variant="outline-secondary"
                            className="input-span-1"
                          >
                            <FaSearch />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </Form>
                  </div>
                </div>
              </Col>
          </Row>
          <Row>
              <Col>
                <Card className="shadow-1 mt-3">
                  <Card.Body className="position-relative overflow-hidden">
                    {loading && <SimpleLoad />}
                    <Row>
                      <Col>
                        <SimpleTable
                          columns={columns}
                          items={items}
                          className="th-text-uppercase"
                        />
                      </Col>
                    </Row>
                    {items.length > 0 && (
                      <div className="mt-2 d-flex justify-content-end align-items-center">
                        <div className="align-self-center">
                          <ReactPaginate
                            previousLabel={<RiArrowLeftSLine />}
                            nextLabel={<RiArrowRightSLine />}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                          />
                        </div>
                        <div className="align-self-center">
                          <select
                            className="select-pagin"
                            onChange={(e) => setCount(e.target.value)}
                          >
                            <option value="20">20 / {t("pagina")}</option>
                            <option value="30">30 / {t("pagina")}</option>
                            <option value="50">50 / {t("pagina")}</option>
                          </select>
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            <Modal show={modalShow} onHide={handleCloseModal} centered className="border-0">
                {sendingDoc && <SimpleLoad />}
                <Modal.Header>Documentos</Modal.Header>
                <Modal.Body>
                    {
                        !existDocuments && 
                        <Alert variant="info">No existen documentos a descargar</Alert>
                    }
                    <ul>
                        {docuemntosEnviar?.ficha && 
                            <li>
                                <a href={docuemntosEnviar.urlFicha} target="blank">Ficha epidemiológica.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.historia && 
                            <li>
                                <a href={docuemntosEnviar.urlHistoria} target="blank">Historia clínica.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.receta && 
                            <li>
                                <a href={docuemntosEnviar.urlReceta} target="blank">Receta.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.incapacidad && 
                            <li>
                                <a href={docuemntosEnviar.urlIncapacidad} target="blank">Incapacidad.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.recomendacion && 
                            <li>
                                <a href={docuemntosEnviar.urlRecomendacion} target="blank">Recomendación médica.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.remision && 
                            <li>
                                <a href={docuemntosEnviar.urlRemision} target="blank">Remisiones.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.estudios && 
                            <li>
                                <a href={docuemntosEnviar.urlEstudios} target="blank">Estudios imagenológicos.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.laboratorio && 
                            <li>
                                <a href={docuemntosEnviar.urlLaboratorio} target="blank">Laboratorios.</a>                                
                            </li>
                        }
                    </ul>

                    <Row>
                        <Col className="text-right">
                            <Button 
                                variant="primary" 
                                className="btn1"
                                onClick={handleCloseModal}
                            >Aceptar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
      )
    }

  return (  
      <Row>
        <Col>
          {trazabilityPage && listTrazability()}
          {documentPage  &&  <ListDocuments onChangeLoadPage={onChangeLoadPage} items={documents} infoCita={infoCita}/>}
          {chatPage && <ListChats onChangeLoadPage={onChangeLoadPage} items={chats} expediente={expediente}/>}
          {recordingPage && <ListRecording onChangeLoadPage={onChangeLoadPage} items={records}/>}
          {notificacionPage && <ListNotificacion onChangeLoadPage={onChangeLoadPage} items={notificaciones}/>}
          {surveyPage && <Survey onChangeLoadPage={onChangeLoadPage} items={surveys}/>}
          <ModalDetailAppointment show={detailPage} closeModal={setDetailPage} infoCita={infoCita} setInfoCita={setInfoCita}/>
        </Col>
      </Row>
  );
}

export default withTranslation()(Trazability);